<template>
  <el-dialog
    v-model="dialogVisible"
    :width="650"
    v-bind="$attrs"
    center
    :show-close="false"
    class="custom-dialog"
  >
    <div class="text">
      {{ tipsText }}
    </div>
    <template #footer>
      <div class="dialog-footer flex justify-center mt-5">
        <el-button @click="handleConfirm" class="confirm-button !ml-0">
          {{ t("shared.common.contactUs") }}
        </el-button>
        <el-button
          type="primary"
          @click="handleContinue"
          class="confirm-button !ml-0"
        >
          {{ t("shared.common.continueBooking") }}
        </el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { computed, onBeforeUnmount, ref } from "vue";
import { useI18n } from "vue-i18n";
import bus from "vue3-eventbus";

const { t } = useI18n();

const dialogVisible = ref(false);
const clickRate = ref(null);

const tipsText = computed(() => {
  return t("shared.hotel.hotelDetail.amanBookingTip");
});

const handleConfirm = () => {
  dialogVisible.value = false;
  window.open("https://lin.ee/11giJoJ");
};

const handleContinue = () => {
  dialogVisible.value = false;
  bus.emit("bookHotelRate", { rate: clickRate.value });
};

const handleOnShow = ({ rate }) => {
  dialogVisible.value = true;
  clickRate.value = rate;
};

bus.on("showBookTipDialog", handleOnShow);

onBeforeUnmount(() => {
  bus.off("showBookTipDialog", handleOnShow);
});
</script>

<style lang="scss" scoped>
.dialog-footer {
  --el-border-radius-base: 0;
  gap: 20px;
  .el-button {
    height: 44px;
    font-size: 16px;
  }
  .confirm-button {
    max-width: 50%;
    min-width: 160px;
  }
}
</style>
<style lang="scss" scoped>
.custom-dialog {
  --el-dialog-padding-primary: 48px 64px;
  .el-dialog__title {
    display: none;
  }
}
</style>
